import { Form, Modal } from 'antd';
import moment from 'moment';
import { useEffect } from 'react';
import SettleInstallmentSingleForm from './SettleInstallmentPartiallyForm';
import { SettleInstallmentPartiallyFormValues } from './SettleInstallmentPartiallyForm/types';
import { SettleInstallmentPatiallyModalProps } from './types';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';

const SettleInstallmentPartiallyModal: React.FC<
  SettleInstallmentPatiallyModalProps
> = ({ onOk, onCancel, data, ...props }) => {
  const [form] = Form.useForm<SettleInstallmentPartiallyFormValues>();

  const today = moment().format('YYYY-MM-DD');
  const payDate = Form.useWatch('payDate', form);

  const isEarlierDate = moment(payDate).isBefore(today);

  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        dueDate: moment().add(1, 'months'),
        payDate: moment(),
        ...data,
      });
    }
  }, [data]);

  async function handleOk() {
    try {
      const values = await form.validateFields();

      await onOk(values);
      handleCancel();
    } catch {}
  }

  function handleCancel() {
    onCancel();
    form.resetFields();
  }

  return (
    <Modal
      title="Liquidar parcialmente a parcela"
      okText="Liquidar"
      {...props}
      onCancel={handleCancel}
      onOk={handleOk}
      width={500}
      okButtonProps={{
        disabled:
          isEarlierDate &&
          !hasPermissions([
            Authorities.FINANCIAL_ACCOUNT_RECEIVABLE_SETTLE_REFUND_WITH_PREVIOUS_DATE,
          ]),
      }}
    >
      <SettleInstallmentSingleForm form={form} />
    </Modal>
  );
};

export default SettleInstallmentPartiallyModal;
